module.exports = __webpack_public_path__ + "static/img/1_1_4.cd13aa52.jpg";